<template>
    <!-- <div class="gj_header gj_top_header"> -->
    <div class="gj_header">
        <div class="content_box">
            <!-- <a class="logo_img" href="/gjindex"></a> -->
            <router-link class="logo_img" to="/gjindex"></router-link>
            <div class="top_nav_right_box">
                
               <div class="nav_item" v-for="(menu, index) in navMenu" :key="index">
                    <span @click="clickRoute(menu.route)">{{menu.name}}</span>
                    <template v-if="menu.level">
                        <i class="icon"></i>
                        <div class="sub_item_box">
                            <p @click="clickRoute(secondMenu.route)" :class="{'active': secondMenu.route == activeName}" v-for="(secondMenu, secondIndex) in menu.level" :key="secondIndex">{{secondMenu.name}}</p>
                            <!-- <p class="active">企业估值</p> -->
                            <!-- <p>股权激励</p> -->
                        </div>
                    </template>
                </div>
                <!-- <div class="nav_item">
                    <span>首页</span>
                </div>
                <div class="nav_item">
                    <span>股权工具</span>
                    <i class="icon"></i>
                    <div class="sub_item_box">
                        <p class="active">企业估值</p>
                        <p>股权激励</p>
                    </div>
                </div>
                <div class="nav_item">
                    <span>股权学习</span>
                </div>
                <div class="nav_item">
                    <span>定制服务</span>
                </div>
                <div class="nav_item" style="margin-right: 0;">
                    <span>关于我们</span>
                </div> -->
                <div class="line"></div>
                <el-button @click="loginBtn" v-if='!user.isLogin' type="primary" size="small" round>登录/注册</el-button>
                <div v-if='user.isLogin' class="user_box">
                    <img class="cursor" :src="user.logourl === '' ? require('@/common/images/header/user.png') : user.logourl" alt="">
                    <span class="cursor">{{user.nickname}}</span>
                    <div class="user_handle_box">
                        <p style="padding: 0 10px;">{{user.nickname}}</p>
                        <p class="cursor_class" @click="clickRoute('GJMyReport')">我的报告</p>
                        <p @click="clickRoute('GJInfo')" class="cursor_class">个人信息</p>
                        <p @click="clickRoute('GJUpdatePassword')" class="cursor_class">修改密码</p>
                        <p @click="exitLogin" class="cursor_class">退出登录</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import $ from 'jquery'
export default {
    name: 'pageHeader',
    data() {
        return {
            activeName: this.$route.name,
            navMenu: [
                {name: "首页", route: "GJIndex"},
                {name: "股权工具", route:"", level: [
                    {name: "企业估值", route: "EnterpriseEstimation"},
                    {name: "股权激励", route: "Excitation"}
                ]},
                {name: "股权学习", route: "EquityLearning"},
                {name: "定制服务", route: "Individualization"},
                {name: "关于我们", route: "gywm"}
            ]
        }
    },
    mounted() {},
    methods: {
        clickRoute(route) {
            if (route == "gywm") {
                this.$router.push({name: 'GJIndex',query: {data: 'gywm'}})
            } else {
                this.$router.push({name: route})
            }
        },
        clickToReport() {
            if (this.user.loginToken) {
                window.open(`${this.domainlist.url_report}/reportindex?token=${this.user.loginToken}`)
            } else {
                window.open(`${this.domainlist.url_report}/reportindex`)
            }
        },
        // 搜索框前面选择搜索内型
        selectSearchType (val) {
            this.searchType = val
        },
        justSearch() {
            let pageName = this.$router.history.current.name
            if (pageName == "Search") {
                this.searchData = this.$route.query.data
            }
        },
        // 登录、注册弹窗
        loginBtn() {
            this.setLoginPop(true)
        },
        search() {  // 搜索课程
            let domain = 1
            if(window.location.hostname.indexOf('ke.capwhale.com')>=0){
                domain = 1
            } else {
                domain = 2
            }
            // console.log(this.searchType)
            switch(this.searchType) {
                case '全部':
                    this.$router.push({name: 'AllSearch',query: {data: this.searchData}})
                    break;
                case '报告':
                    if (domain === 1) {
                        // location.href = `${this.domainlist.url_course}/search?data=${this.searchData}&searchtype=1`
                        window.open(`${this.domainlist.url_report}/reportsearch?data=${this.searchData}&token=`+this.user.loginToken)
                    } else {
                        this.$router.push({name: 'ReportSearch',query: {data: this.searchData}})
                    }
                    break;
                case '课程':
                    this.$router.push({name: 'Search',query: {data: this.searchData}})
                    break;
                case '题库':
                    this.$router.push({name: 'QuestionSearch',query: {data: this.searchData}})
                    break;
            }
            // if (this.searchData.length > 0) {
            //     this.$router.push({name: 'ReportSearch',query: {data: this.searchData}})
            // } else {
            //     this.$router.push({name: 'ReportSearch'})
            // }
        },
        // 退出登录
        exitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this.$message.success('退出成功！')
            this.$router.push({name: "GJIndex"})
        },
        // 前往个人中心页面
        gotoRouterPersonalCenter() {
            // this.$router.push({name: 'ClassScheduleCard'})
            if (this.user.loginToken) {
                window.location.replace(`${this.domainlist.url_my}/personalCenter/ClassScheduleCard?token=${this.user.loginToken}&type=1`)
            } else {
                window.location.replace(`${this.domainlist.url_my}/personalCenter/ClassScheduleCard&type=1`)
            }
        },
        // 上传点击跳转到https://admin.jkt.capwhale.com/login
        uploadingClick() {
            if (this.user.isLogin) {
                window.open('https://czadmin.capwhale.com/creativeCenter?token=' + this.user.loginToken, '_blank')
            } else {
                window.open('https://czadmin.capwhale.com/login', '_blank')
            }
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    watch: {
        $route: {
            handler (val) { // val 更新的, oldVal 过去的
                this.justSearch()
                // index 页面下样式删除
                if (val.name !== "Index") {
                    // console.log('删除')
                    $(".PHome .header").removeClass("index_top_header")
                } else {
                    // index 页面下样式绑定
                    $(".PHome .header").addClass("index_top_header")
                }
                this.activeName = this.$route.name
            },
            // 深度观察监听
            deep: true
        }
    },
    filters: {},
    computed: {
        ...mapGetters(
            ['user', 'domainlist']
        )
    },
    components: {

    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .gj_header{
        box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
        width: 100%;
        height: 64px;
        background-color: rgb(255, 255, 255);
        position: fixed;
        top: 0;
        z-index: 100;
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        .content_box {
            width: 1200px;
            height: 64px;
            margin: 0 auto;
            // padding-left: 20px;
            padding: 0 20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .logo_img {
                width: 98px;
                min-width: 98px;
                height: 32px;
                min-height: 32px;
                background-image: url('../../common/images/gujingimgs/logo1.png');
                background-size:98px 32px;
            }
            .top_nav_right_box {
                display: flex;
                align-items: center;
                .line {
                    width: 1px;
                    height: 20px;
                    background-color: rgba(255,255,255,.7);
                    margin: 0 30px;
                }
                .user_box {
                    padding: 14px 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    &>img {
                        width: 36px;
                        height: 36px;
                        border-radius: 100%;
                    }
                    &>span {
                        line-height: 22px;
                        margin-left: 4px;
                        color: #666;
                        font-size: 16px;
                        max-width: 64px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    .user_handle_box {
                        display: none;
                        // box-shadow:0px 0px 4px 0px rgba(0,0,0,0.15);
                        box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);
                        border-radius:6px;
                        background-color: #fff;
                        position: absolute;
                        left: -30px;
                        top: 60px;
                        &>p {
                            line-height: 40px;
                            width: 120px;
                            text-align: center;
                            // border-bottom: 1px solid #E5E5E5;
                            box-sizing: border-box;
                            color: #999;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                        }
                        .cursor_class{
                            cursor: pointer;
                            &:hover {
                                color: #409EFF;
                            }
                            
                        }
                        p:nth-last-of-type(1){
                           border-top: 1px solid #E5E5E5;
                        }
                        p:nth-last-of-type(5){
                           border-bottom: 1px solid #E5E5E5;
                        }
                        // p:nth-last-of-type(1):hover{
                        //     color: rgb(27, 138, 248);
                        // }
                    }
                }
                .user_box:hover{
                    .user_handle_box {
                        display: block;
                        animation: useranimation 1s;
                        -webkit-animation: useranimation 1s;
                        -ms-animation: useranimation 1s;
                        -moz-animation: useranimation 1s;
                    }
                }
                @keyframes useranimation {
                    0% {
                        top: 70px;
                        opacity: 0;
                    }
                    100% {
                        top: 60px;
                        opacity: 1;
                    }
                }
                .nav_item {
                    position: relative;
                    height: 30px;
                    margin-right: 40px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    &>span {
                        color: #333;
                        font-size:16px;
                    }
                    &>i {
                        margin-left: 6px;
                        display: inline-block;
                        width: 8px;
                        height: 6px;
                        background-image: url('../../common/images/gujingimgs/icon_arrows1.png');
                        background-size:8px 6px;
                    }
                    .sub_item_box {
                        box-shadow:0px 0px 4px 0px rgba(0,0,0,0.15);
                        display: none;
                        position: absolute;
                        left: 0;
                        top: 30px;
                        width:156px;
                        // height:186px;

                        padding: 14px 0;
                        box-sizing: border-box;
                        background:rgba(255,255,255,1);
                        border-radius:6px;
                        &>p {
                            box-sizing: border-box;
                            color: #999;
                            font-size: 16px;
                            line-height: 30px;
                            padding-left: 30px;

                        }
                        .active {
                            padding-left: 27px;
                            color: #333;
                            border-left: 3px solid #409EFF;
                        }
                        &>p:hover {
                            padding-left: 27px;
                            color: #333;
                            border-left: 3px solid #409EFF;
                            transition: all .2s;
                            -webkit-transition: all .2s;
                            -ms-transition: all .2s;
                            -moz-transition: all .2s;
                            -o-transition: all .2s;
                        }
                    }
                }
                .nav_item:hover {
                    &>span {
                        color: #409EFF;
                    }
                    &>i {
                        background-image: url('../../common/images/gujingimgs/icon_arrows2.png');
                    }
                    .sub_item_box {
                        display: block;
                        animation: subanimation 1s;
                        -webkit-animation: subanimation 1s;
                        -ms-animation: subanimation 1s;
                        -moz-animation: subanimation 1s;
                    }
                }
                @keyframes subanimation {
                    0% {
                        top: 40px;
                        opacity: 0;
                    }
                    100% {
                        top: 30px;
                        opacity: 1;
                    }
                }
                .el-button{
                    width: 94px;
                    height: 30px;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    padding: 0;
                    justify-content: center;
                }
            }
        }
    }
    .gj_top_header {
        background: transparent!important;
        box-shadow:none;
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        .content_box {
            .logo_img {
                background-image: url('../../common/images/gujingimgs/logo2.png');
            }
            .top_nav_right_box {
                .user_box {
                    &>span {
                        color: rgba(255,255,255,.7);
                    }
                    // &>span:hover {
                    //     color: rgba(255,255,255);
                    // }
                }
                .user_box:hover {
                    &>span {
                        color: rgba(255,255,255);
                    }
                }
                .nav_item {
                    &>span {
                        color:rgba(255,255,255,.7);
                    }
                    &>i {
                        background-image: url('../../common/images/gujingimgs/icon_arrows4.png');
                    }
                }
                .nav_item:hover {
                    &>span {
                        color: rgb(255, 255, 255);
                    }
                    &>i {
                        background-image: url('../../common/images/gujingimgs/icon_arrows3.png');
                    }
                }
                .el-button{
                    background: transparent!important;
                    color:rgba(255,255,255,.7);
                    border: 1px solid rgba(255,255,255,.7);;
                }
                .el-button:hover{
                    color:rgba(255,255,255);
                    border: 1px solid rgba(255,255,255);;
                }
            }
        }
    }
</style>